import React from "react";
import styled from "styled-components";
import { I18n } from "@aws-amplify/core";

import media from "../../utils/media";
import GlobalBibleLogoIcon from "../../icons/GlobalBibleLogoIcon";

const FooterDiv = styled.div`
  padding: 1em 0;
  padding-bottom: 3em;
  display: none;
  color: #b2b8bd !important;
  ${media.desktop`
    display:block;
    position: relative;
    width: ${props => (props.hasParallels ? "86%" : "80%")};
    max-width: ${props => (props.hasParallels ? "86%" : "800px")};
    margin: 0 auto;
    `};
  a {
    text-decoration: none;
    font-size: 0.75em;
    color: #aaaaaa;
    transition: color 0.5s ease;
    &:hover {
      color: ${props => props.theme.computedPrimary};
    }
  }
`;

const Logo = styled.div`
  display: inline-block;
  width: 24px;
  opacity: 0.5;
  vertical-align: middle;
  margin-right: 0.5em;
`;

const LeftLink = styled.a`
  position: absolute;
  left: 1em;
`;

const RightLinks = styled.span`
  position: absolute;
  right: 1em;
`;

const Footer = ({ props }) => (
  <FooterDiv {...props}>
    <LeftLink to="https://global.bible">
      <Logo>
        <GlobalBibleLogoIcon size={24} color="gray" />
      </Logo>
      The Global Bible Project
    </LeftLink>
    <RightLinks>
      <a href="/privacy" target="_blank">
        {I18n.get("Privacy")}
      </a>{" "}
      |{" "}
      <a href="/terms" target="_blank">
        {I18n.get("Terms and Conditions")}
      </a>
    </RightLinks>
  </FooterDiv>
);

export default Footer;
